import backofficeService from '../../api/backoffice'

export default {
  searchSerialNumber(params) {
    return backofficeService.Api().get('api/purchase/searchSerialNumber', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getById(id) {
    return backofficeService.Api().get(`api/invoice/bystoreId/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getAll(params) {
    return backofficeService.Api().get(`api/invoice/byQuery`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getInvoiceByID(id) {
    return backofficeService.Api().get(`api/invoice/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getOpenInvoice() {
    return backofficeService.Api().get('api/invoice/byQuery?list=open')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  missingSerialNumber(id) {
    return backofficeService.Api().get(`api/invoice/missingSerailList/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getPassedDueInvoice() {
    return backofficeService.Api().get('api/invoice/byQuery?list=passedDue')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getInvoiceProduct(params) {
    return backofficeService.Api().get('api/getInvoiceProduct', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getManualChargeInvoice() {
    return backofficeService.Api().get('api/invoice/byQuery?list=manual-open')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getReadyToBeMadeInvoice() {
    return backofficeService.Api().get('api/invoice/readytobemade')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  invoiceDelete(id, data) {
    console.log('in service', id, data)
    return backofficeService.Api().post(`api/invoice/delete/${id}`, data)
      .then(response => {
        console.log('response.data', response)
        return response.data
      })
      .catch((error) => { throw error })
  },
  getByIdDeleted(id) {
    return backofficeService.Api().get(`api/invoice/getDeletedInviocesByStoreId/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getAllInvoice(id, params) {
    return backofficeService.Api().get(`api/invoice/getInviocesByStoreId/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getInvoiceById(id, params) {
    console.log('req.params.invoiceID', id)
    return backofficeService.Api().get(`api/invoice/${id.id}`, { params })
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  getStripeCard(id) {
    return backofficeService.Api().get(`api/stripe/cards/${id}`)
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  emailInvoice(id, data) {
    return backofficeService.Api().post(`api/invoice/email/${id}`, data)
      .then(response => {
        return response.data
      }).catch((error) => { throw error })
  },
  renewInvoice(storeID, serviceID) {
    return backofficeService.Api().post(`api/invoice/renew/${storeID}/${serviceID}`)
      .then(response => {
        return response.data
      }).catch((error) => { throw error })
  },
  unPaid(id, data) {
    return backofficeService.Api().post(`api/invoice/unPaid/${id}`, data)
      .then(response => {
        return response.data
      }).catch((error) => { throw error })
  },
  stripeRefund(id, data) {
    return backofficeService.Api().post(`api/invoice/stripeRefund/${id}`, data)
      .then(response => {
        return response.data
      }).catch((error) => { throw error })
  },
  getStripeCharge(id) {
    return backofficeService.Api().get(`api/stripe/charge/${id}`)
      .then(response => {
        return response.data
      }).catch((error) => { throw error })
  },
  updateInvoice(id, data) {
    return backofficeService.Api().put(`api/invoice/${id}`, data)
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  createInvoice(data) {
    return backofficeService.Api().post('api/invoice', data)
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  collectInvoice(id, data) {
    return backofficeService.Api().post(`api/invoice/charge/${id}`, data)
      .then(response => {
        console.log('invoice Collected', response)
        return response.data
      })
      .catch((error) => { throw error })
  },
  chargeManual(id, data) {
    return backofficeService.Api().post(`api/invoice/chargemanual/${id}`, data)
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  /**
   * create credit card
   * @param {*} params Query Options
   */
  addCreditCard(data) {
    let url = null
    if (data.stripeID) {
      url = 'api/stripe'
    } else {
      url = 'api/stripe/createCustomer'
    }
    return backofficeService.Api().post(url, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

}
